//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import AppFaqs from '@/components/AppFaqs.vue';
import CallToAction from '@/components/elements/CallToAction.vue';
const faqs = require('~/content/raw/faqs.js').default;
export default {
  components: { AppFaqs, CallToAction },
  head() {
    return {
      title: 'FAQs | BOMIST',
      meta: [
        {
          hid: 'description',
          name: 'description',
          content:
            'Answers to common questions about BOMIST plans, offline use, team workspaces, billing and cancellations.'
        }
      ],
      script: [
        {
          type: 'application/ld+json',
          json: {
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            mainEntity: faqs.map((faq) => ({
              '@type': 'Question',
              name: faq.title,
              acceptedAnswer: {
                '@type': 'Answer',
                text: faq.description
              }
            }))
          }
        }
      ]
    };
  }
};
